module.exports = __webpack_public_path__ + "img/logo.a6a591b4.png";